import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetProblemType } from "../queries/problemTypes";
import { ENTITY } from "../constants";

export const ProblemTypeBreadcrumb = ({ match }) => {
    // Entity
    const { PROBLEMTYPE } = ENTITY;

    const {
      data: problemType,
      isLoading,
      isError,
      error,
    } = useGetProblemType(match.params.problemTypeId);
  
    if (isLoading) {
      //return <span>Loading...</span>;
      return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
    }
  
    if (isError && error instanceof NotFoundException) {
      return <span>Not found</span>;
    }
  
    if (problemType) {
      return <span>{trimString(problemType[PROBLEMTYPE.nameField], 20)}</span>;
    }
  
    return null;
  };